import React, { Fragment } from 'react';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faFileDownload
    , faSearchDollar
  } from '@fortawesome/free-solid-svg-icons';

const ReporteReducidoPie = () => {
  return (
    <Fragment>
        <div className='card border-secondary mt-3'>
            {/*<div classname='card-header>Header</div>*/}
            <div className='card-body text-primary'>
                <ul className='c-azulEP'>
                    <h6 className='text-end'>
                        -- Para ver los Datelles de tu Gestión pudes verlo en <Link to='/resultados' className='menu-bars' data-toggle='tooltip' data-placement='top' title='Menu Resultados'><FontAwesomeIcon className='c-azulEP' icon={faSearchDollar} size='lg'/> Resultados</Link>
                    </h6>
                    <h6 className='text-end'>
                        -- Revisa tu BBDD y modifícala en menú "Mi Prospeccion", Opción: <Link to='/mi-prospeccion' className='menu-bars' data-toggle='tooltip' data-placement='top' title='Menu Mi Prospección'><FontAwesomeIcon className='c-azulEP' icon={faFileDownload} size='lg'/> Base de Prospección</Link>
                    </h6>
                </ul>
            </div>
        </div>
    </Fragment>
  )
}

export default ReporteReducidoPie;